<!-- 图文详情 -->
<template>
    <div v-if="componentsData.type == 8"
        :style="`
            padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px; background: ${componentsData.content.bg_color};
            border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;
        `"
    >
        <div class="ql-editor" v-html="componentsData.content.text"></div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style>
.ql-editor {
    padding: 0 !important;
}
.ql-editor img {
    width: 100% !important;
}
</style>